import React from "react"

export const LabelGroup = ({ children, labelValue, forId }) => (
  <div className="label-value">
    <label htmlFor={forId}>{labelValue}</label>
    {children}
  </div>
)
